import { getCountryForTimezone } from "countries-and-timezones";

/**
 * Get the user's country based on their time zone. Returns the Alpha-2 code of the country.
 */
export function getEstimatedUserCountry() {
  if (import.meta.server) return undefined;

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return getCountryForTimezone(userTimeZone)?.id;
}
